import React from "react";

const MAP =
  '<a href="https://goo.gl/maps/SUQ6WCT4tik" target="_blank"><img src="https://smokini.bg/system/images/assets/000/000/957/original/smokini-map.png" alt="Map to Smokini" /></a>';

class SiteFooter extends React.Component {
  render() {
    const { page_context } = this.props;
    const { footer_menu, events, posts, layout_translations } = page_context;
    const {
      events_title,
      restaurant,
      address_phone_title,
      smokini,
      address_street,
      address_city,
      navigation_caps,
      blog,
      social,
      description,
      all_rights,
      created_by,
      navigation,
      reservations,
      call,
    } = layout_translations;
    const { items } = footer_menu;

    return (
      <footer className="site-footer">
        <div className="container desktop-footer">
          <div className="row">
            <div className="col-2">
              <h6>{restaurant}</h6>
              <ul>
                {items.map((item, idx) => (
                  <li key={idx}>
                    <a href={item.link}>{item.label}</a>
                  </li>
                ))}
              </ul>

              <h6>{address_phone_title}</h6>
              <p>
                {smokini} <br /> {address_street} <br /> {address_city}, <br />{" "}
                4000 <br /> +359 999 000 996
              </p>
            </div>

            <div className="col-4">
              <h6>{events_title}</h6>
              <ul>
                {events.map((event) => (
                  <li key={event.id}>
                    <a href={event.url}>{event.title}</a>
                  </li>
                ))}
              </ul>

              <h6>{navigation_caps}</h6>
              <div
                className="map-wrapper"
                dangerouslySetInnerHTML={{ __html: MAP }}
              />
            </div>

            <div className="col-6">
              <h6>{blog}</h6>

              <ul>
                {posts.map((post) => (
                  <li key={post.id}>
                    <a href={post.url}>{post.title}</a>
                  </li>
                ))}
              </ul>

              <h6>{social}</h6>
              <p>{description}</p>

              <div className="social-bar">
                <a
                  href="https://www.facebook.com/smokini.bg"
                  className="facebook"
                  rel="me"
                  target="_blank"
                ></a>
                <a
                  href="https://www.instagram.com/smokini.bg/"
                  className="instagram"
                  rel="me"
                  target="_blank"
                ></a>
                <a
                  href="https://www.tripadvisor.com/Restaurant_Review-g295391-d11875549-Reviews-Smokini-Plovdiv_Plovdiv_Province.html"
                  className="trip"
                  rel="me"
                  target="_blank"
                ></a>
                <a
                  href="https://foursquare.com/v/smokini/581c8c9c001d871478e3d239"
                  className="fsqr"
                  rel="me"
                  target="_blank"
                ></a>
              </div>

              <p>
                Smokini Copyright © 2016. {all_rights} <br /> {created_by}{" "}
                <a href="https://touchawesome.com/" target="_blank">
                  <img
                    src="data:image/svg+xml;base64,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"
                    alt="Touch Awesome"
                    className="touch-awesome-logo"
                  />
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="mobile-footer">
          <div className="container">
            <div className="row-wrapper">
              <div className="mobile-row">
                <h6>{address_phone_title}</h6>
                <p>
                  {address_street} {address_city}
                </p>
              </div>

              <a
                href="https://www.google.bg/maps/place/Smokini/@42.147,24.7466203,17z/data=!3m1!4b1!4m5!3m4!1s0x14acd1bca7217f4b:0x5e12c734cbe65975!8m2!3d42.146996!4d24.748809"
                className="btn-primary-alt"
                target="_blank"
                id="cta-navigation-footer-mobile"
              >
                {navigation}
              </a>
            </div>

            <div className="map">
              <div dangerouslySetInnerHTML={{ __html: MAP }} />
            </div>

            <div className="row-wrapper">
              <div className="mobile-row">
                <h6>{reservations}</h6>
                <p>+359 999 000 996</p>
              </div>

              <a
                href="tel:+359999000996"
                className="btn-primary-alt"
                id="cta-call-footer-mobile"
              >
                {call}
              </a>
            </div>

            <p>{description}</p>

            <p className="credits">
              Awesome Mobile Expirience by <br />{" "}
              <a href="https://touchawesome.com/" target="_blank">
                <img
                  src="data:image/svg+xml;base64,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"
                  alt="Touch Awesome"
                  className="touch-awesome-logo"
                />
              </a>
            </p>
          </div>

          <div className="social-bar">
            <a
              href="https://www.facebook.com/smokini.bg"
              className="facebook"
              target="_blank"
              id="mobile-footer-facebook"
            ></a>
            <a
              href="https://www.instagram.com/smokini.bg/"
              className="instagram"
              target="_blank"
              id="mobile-footer-instagram"
            ></a>
            <a
              href="https://www.tripadvisor.com/Restaurant_Review-g295391-d11875549-Reviews-Smokini-Plovdiv_Plovdiv_Province.html"
              className="trip"
              target="_blank"
              id="mobile-footer-tripadvisor"
            ></a>
            <a
              href="https://foursquare.com/v/smokini/581c8c9c001d871478e3d239"
              className="fsqr"
              target="_blank"
              id="mobile-footer-foursquare"
            ></a>
          </div>
        </div>
      </footer>
    );
  }
}

export default SiteFooter;
